import React, {Component} from 'react';
//import {Table, Button, ButtonToolbar} from 'react-bootstrap';
import { Button, ButtonToolbar} from 'react-bootstrap';
//import { Router, Route, Switch, Link } from "react-router-dom";
import { FormattedDate } from 'react-intl';
import {AddTramitesModal} from './addtramitesmodal';
import {EditTramitesModal} from './edittramitesmodal';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import './SuperResponsiveTableStyle.css';
import {getApi} from "../App";


//const API_TRAMITES = 'http://st.panalcobranzas.com.py:8082/tramites/exp/';
//const API_API_TRAMITES_DELETE = 'http://st.panalcobranzas.com.py:8082/tramites/';


export class Tramite extends Component {
    
    constructor(props) {
        super (props);
        console.log ('constructor');
    
        this.state={
            tramites: [],
            isLoading: true,
            error: null,
            addModalShow: false,
            editModalShow: false,
            id: props.match.params.id
        }
    }

    componentDidMount () {
        this.refreshList();    
    }

    deleteTramite(idTramite) {
        if ( window.confirm ('Está seguro que desea eliminar el registro?')) {
            getApi().deleteTramites(idTramite)
            .then(response=>  {
                if ( response.ok ) {
                    alert('Registro Eliminado correctamente');
                    this.refreshList();
                    return 'Registro eliminado' ;
                } else {
                    this.setState({error: new Error('Error al recuperar los datos de la API REST...'), isLoading: false});
                }
            })
            .catch(error => {
                this.setState({error: new Error('El registro no pudo ser eliminado...'), isLoading: false});
                console.error('Hubo un error!', error);
            });
                
        }

    }

    refreshList() {
        const idExpediente = this.state.id.toString();

        getApi().getTramites(idExpediente)
        .then(data => {this.setState ({tramites: data, isLoading: false })})
        .catch(error => this.setState({error, isLoading: false}));
  
  
            
    }        
 
    render () {
        const {tramites, isLoading, error,
              identificador, idExpediente, fechahora, tipoTramite, 
              resposable, observ} = this.state; 
        let addModalClose =() => this.setState({addModalShow: false});
        let editModalClose =() => this.setState({editModalShow: false});
        

        console.log ('render');
        let tramiteIni = tramites[0];

        if ( error ) {
            console.log ('error en el render');
            return (
            <p>Se produjo un error. {error.message}</p>
            );
        }
        if ( isLoading ) {
            return (<p>Cargando datos...</p>) ;
        }
        return (
            
            <div className="container">
                 <div className='mt-4'>
                    <h5>
                        Causa: {tramiteIni.caratula}
                    </h5>
                </div>
                <ButtonToolbar>
                    <Button variant="primary" 
                        onClick= {()=> this.setState({addModalShow: true})}
                    >
                        Agregar Tramite 
                    </Button> 
                    <AddTramitesModal idExpediente={this.state.id}
                      show={this.state.addModalShow}
                      onClose={() => { 
                          this.setState({ addModalShow: false });
                          this.refreshList();
                        }}
                      onHide={addModalClose}
                    />
                </ButtonToolbar>                
                <Table className="mt-4" striped bordered hover size="sm">
                    <Thead>
                    <Tr>
                        <Th>Fecha</Th>
                        <Th>Tipo de Trámite</Th>
                        <Th>Observación</Th>
                        <Th>Responsable</Th>
                        <Th>Acciones</Th>
                        
                    </Tr>
                    </Thead>
                    <Tbody>
                    {tramites.map(tramite => (
                        
                        <Tr key={tramite.identificador}>
                        <Td align="left">{
                            <FormattedDate
                            value={tramite.fechahora}
                            day="2-digit"
                            month="2-digit"
                            year="numeric"
                            />
                        }</Td>
                        
                        <Td>{tramite.tipotramite_Descrip}</Td>
                        <Td>{tramite.observ}</Td>
                        <Td>{tramite.resposable}</Td>
                        <Td>
                            <ButtonToolbar>
                                <Button 
                                    className="mr-2" variant="info"
                                    onClick={()=> this.setState ({editModalShow:true,
                                        identificador:tramite.identificador, 
                                        idExpediente:tramite.identexpediente, 
                                        fechahora:tramite.fechahora, 
                                        tipoTramite:tramite.tipotramite,
                                        resposable:tramite.resposable, 
                                        observ:tramite.observ
                                    })}
                                >
                                    Editar
                                </Button>
                                <Button className="mr-2" variant="danger"
                                    onClick ={()=> this.deleteTramite(tramite.identificador)}>
                                        Eliminar
                                    </Button>
                                <EditTramitesModal 
                                    show = {this.state.editModalShow}
                                    onHide = {editModalClose}
                                    identificador = {identificador}
                                    idExpediente = {idExpediente}
                                    fechahora = {fechahora} 
                                    tipoTramite = {tipoTramite}
                                    resposable = {resposable}
                                    observ = {observ}
                                    onClose={() => { 
                                        this.setState({ editModalShow: false });
                                        this.refreshList();
                                      }}
                                />
                            </ButtonToolbar>
                        
                        </Td>   
                        </Tr>
                        
                    ))}
                    </Tbody>                    
                </Table>
              
            </div>
           
        );
    }
}